import * as React from "react"
export const UserIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    className="fill-fg-1"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.32789 23.7768C6.33491 20.5874 10.4473 18.6 15.001 18.6C19.5547 18.6 23.6671 20.5874 26.6741 23.7768C27.0027 24.1253 27.0926 24.6357 26.9028 25.0755C26.713 25.5152 26.2799 25.8 25.801 25.8H4.201C3.72207 25.8 3.28899 25.5152 3.09922 25.0755C2.90945 24.6357 2.99933 24.1253 3.32789 23.7768Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.401 9.6C8.401 5.95492 11.3559 3 15.001 3C18.6461 3 21.601 5.95492 21.601 9.6C21.601 13.2451 18.6461 16.2 15.001 16.2C11.3559 16.2 8.401 13.2451 8.401 9.6Z"
    />
  </svg>
)
